import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { unwrapPagedResponseModel, unwrapResponseModel } from '../api/responseModel';

const INDEX_PATH = '/api/MateriaCarrera/Index';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

export function resetMateriasListCacheForTests() {
  // Sin caché deduplicada tras F4-011.
}

export function listMaterias(query = { page: 1, pageSize: 10 }) {
  const qs = buildPagedQuery(query);
  return apiClient.get(`${INDEX_PATH}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
}

export function lookupMaterias(query = { page: 1, pageSize: 5 }) {
  return listMaterias(query);
}

export function getMateria(id) {
  return requestAndUnwrap(apiClient.get(`/api/mxc/${id}`));
}

export function deleteMateria(id) {
  return requestAndUnwrap(apiClient.get(`/api/MateriaCarrera/delete/${id}`));
}

export function saveMateria(payload) {
  return requestAndUnwrap(apiClient.post('/api/Materia', payload));
}
